import React from 'react';
import { Image, useDeviceType } from '@cian/ui-kit';

import { Card, ICardParams } from '../Card';
import * as s from './CardListingItem.css';

export interface IAdfoxCardListingItem {
  height?: ICardParams['height'];
  title: string;
  description: string;
  image: string;
  siteName?: string;
  footnote: string;
  url: string;
}

/**
 * Компонент рекламного блока в виде карточки в списке
 */
export const AdfoxCardListingItem = ({
  image,
  title,
  description,
  siteName,
  footnote,
  url,
  height,
}: IAdfoxCardListingItem) => {
  const deviceType = useDeviceType();
  const isPhone = () => deviceType === 'phone';

  const handleClick = () => {
    window.open(url, '_blank');
  };

  return (
    <Card onClick={handleClick} height={height}>
      <div className={`${s['image-wrapper']} ${s['_adfox']}`}>
        <div className={`${s['adv-label']}`}>Реклама</div>

        <Image
          alt={title}
          borderRadius={0}
          objectFit="cover"
          preloader
          src={image}
          theme="light"
          title={title}
          height={isPhone() ? 109 : 180}
        />
      </div>

      <div className={`${s['content-wrapper']} ${s['_has-image']}`}>
        <div className={`${s['content-wrapper-inner']} ${s['_adfox']}`}>
          <div className={`${s['title']}`} title={title}>
            {title}
          </div>

          <div className={`${s['description']}`} title={description}>
            {description}
          </div>

          {siteName && <div className={`${s['site-name']}`}>{siteName}</div>}

          <div className={`${s['footnote']}`} title={footnote}>
            {footnote}
          </div>
        </div>
      </div>
    </Card>
  );
};
